import { Component, TemplateRef, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ApiService } from 'src/app/components/shared/api.service';
import { localStorageService } from 'src/app/components/shared/localstorage.service';
import { MainService } from 'src/app/components/shared/main.service';
import { SharedService } from 'src/app/components/shared/shared.service';
import { PermissionsService } from 'src/app/components/shared/permissions/permissions.service';
import { NgClass } from '@angular/common';
@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, ReactiveFormsModule, NgClass]
})
export class LoginComponent {
  public loginForm: UntypedFormGroup;
  public forgotPasswordForm: UntypedFormGroup;
  hidePwd: boolean = false;
  step = {
    EMAIL: 'EMAIL',
    PASSWORD: 'PASSWORD',
    VERIFY_OTP: 'VERIFY_OTP',
    FORGOT_PASSWORD: 'FORGOT_PASSWORD'
  };
  loginStep = this.step.EMAIL;
  interval: any;
  refreshTimer = '';
  modalRef?: BsModalRef;

  constructor(private fb: UntypedFormBuilder, public _shared: SharedService, private _main: MainService, private _api: ApiService, private _local: localStorageService, private _router: Router,private modalService: BsModalService, private _permissions: PermissionsService, private _route: ActivatedRoute) {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.maxLength(100)]],
      password: [''],
      otp: [''],
    });
    this.forgotPasswordForm = this.fb.group({
      email: ['', [Validators.required, Validators.maxLength(100)]],
    });
  }
  openModal(template: TemplateRef<void>) {

    if (!this.loginForm.value.email) {
      this._shared.customPopups('Please enter valid email', 1);
      return;
    }
    if (this.loginStep == this.step.VERIFY_OTP) {
      if (!this.loginForm.value.otp) {
        this._shared.customPopups('Please enter valie otp', 1);
        return;
      }  
    } else {
      if (!this.loginForm.value.password) {
        this._shared.customPopups('Please enter valid password', 1);
        return;
      }
    }
    this.modalRef = this.modalService.show(template, {
      class: 'modal-dialog-centered',
    });
  }
  public login() {
    this.modalRef?.hide()

    let data: any = {
      admin_email: this.loginForm.value.email,
    };

    if (this.loginStep == this.step.VERIFY_OTP) {
      data['otp'] = this.loginForm.value.otp;
    } else {
      data['admin_password'] = this._shared.crypto(this.loginForm.value.password)
    }

    this._api.api(data, 'auth/email_login_v2').subscribe(response => {
      if (!response.is_error) {
        if (response.reset_password_token){
          if (response.reset_password_token) {
            navigator.geolocation.getCurrentPosition(() => {});
            this._local.customSetItem('token', response.access_token);
            this._local.customSetItem('reset_password_token', response.reset_password_token);
            this._local.customSetItem('reset_email', response.admin_email);
            this._router.navigate(['new-password']);
            return;
          }
        } else {
          const admin_profile_before_clear = response.admin_profile ? response.admin_profile[0] : {};
          if (admin_profile_before_clear.password_expired) {
            navigator.geolocation.getCurrentPosition(() => {});
            this._local.customClearAllItems();
            this._local.customSetItem('token', response.access_token);
            this._local.customSetItem('admin_profile', admin_profile_before_clear);
            this._local.customSetItem('password_expired', '1');
            this._router.navigate(['force-password-change']);
            return;
          }
          navigator.geolocation.getCurrentPosition(() => {});
          this._local.customClearAllItems();
          this._local.customSetItem('token', response.access_token);
          this._local.customSetItem('admin_profile', response.admin_profile ? response.admin_profile[0] : {});
          if (admin_profile_before_clear.password_expiry_warning_days) {
            const today = new Date().toDateString();
            if (this._local.customGetItem('password_expiry_reminder_shown_on') !== today) {
              this._local.customSetItem('password_expiry_reminder_shown_on', today);
              this._shared.passwordExpiryWarningDays$.next(admin_profile_before_clear.password_expiry_warning_days);
            }
          }
          // Consumed once by MainLayoutComponent to auto-open the Connect
          // Gmail modal after a fresh login. Tied to the login event itself
          // (not a permanent localStorage flag) so it reappears every login,
          // not just once per device. Gated on is_gmail_sync_enable (set
          // per-admin by a super admin via the RBAC Users list) -- when
          // it's off, this admin should never see the modal at all, not
          // even to show it and have the backend reject the connect.
          const admin_profile_data = response.admin_profile ? response.admin_profile[0] : {};
          this._local.customSetItem('show_gmail_connect_modal', !!admin_profile_data.is_gmail_sync_enable);
          // Capability hydration: backend embeds `capabilities` and `dashboards`
          // in the login response (auth/email_login_v2). Storing them here
          // means PermissionsService is ready before any guard runs.
          this._permissions.setFromLoginResponse(response);
          this._main.fetchAdminList();
          if (response.menu && response.menu.length) {
            this._main.menu$.next(response.menu);
          }
          // Session-expired flow: if the user was redirected here from a
          // protected route, send them back to it instead of the default view.
          const returnUrl = this._route.snapshot.queryParams['returnUrl'];
          if (returnUrl) {
            this._router.navigateByUrl(returnUrl);
            return;
          }
          this._shared.dashboardMenuExist(response.menu).then(res => {
            // Default sales view: managers (or super-admin) land on the L1
            // team view, everyone else on their own. Driven by capability,
            // so a future role with VIEW_ALL grants behaves correctly even
            // if its role_enum string changes.
            const defaultSalesView = this._permissions.isManager ? 'L1' : 'my';
            this._local.customSetItem('sales_dashboard_view', defaultSalesView);
            // Sales-aware redirect: any user that can see at least one sales
            // dashboard or has lead-list scope goes to the menu's first
            // entry; otherwise they land on the generic admin dashboard.
            const dashboards = this._permissions.dashboards;
            const hasAnySalesAccess = dashboards.l1 || dashboards.l2 || dashboards.l3 || dashboards.l4
              || this._permissions.isAgent
              || this._permissions.isTeamLead
              || this._permissions.isManager;
            const firstMenuPath = response.menu && response.menu.length ? response.menu[0]['path'] : null;
            if ((res && (!hasAnySalesAccess || this._permissions.isWildcard)) || !firstMenuPath) {
              this._router.navigate(['app', 'dashboard']);
            } else {
              this._router.navigate([firstMenuPath]);
            }
          })
        }
      }
    })
  }
  forgotPassword() {
    if (this.forgotPasswordForm.invalid) {
      this.forgotPasswordForm.markAsDirty();
      this.forgotPasswordForm.markAllAsTouched();
      return;
    }

    const data = {
      admin_email: this.forgotPasswordForm.value.email
    };

    this._api.api(data, 'auth/forgot_password').subscribe(response => {
      if (!response.is_error) {
        this.forgotPasswordForm.reset();
        this._shared.customPopups('Password has been sent successfully', 0);
        this.loginStep = this.step.EMAIL;
      }
    })
  }
  changeloginStep(type: any) {
    if (type === this.step.PASSWORD || type === this.step.VERIFY_OTP) {
      if (!this.loginForm.controls['email'].value) {
        this.loginForm.markAsDirty();
        this.loginForm.markAllAsTouched();
        return;
      } else {
        if (type === this.step.PASSWORD) {
          this.loginStep = type;
        } else if (type === this.step.VERIFY_OTP) {
          if (!this.loginForm.value.email) {
            this._shared.customPopups('Please enter valid email', 1);
            return;
          }
          const data = {
            admin_email: this.loginForm.value.email
          };
          this._api.api(data, 'auth/auth_otp').subscribe(response => {
            if (!response.is_error) {
              this.loginStep = type;
              this.countDown(90);
            }
          })
        } else {
          console.log('Invalid Type');
        }
      }
    } else if (type === this.step.EMAIL){
      this.loginStep = type;
      this.clearCountDown();
    }
  }
  clearCountDown() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
      this.refreshTimer = '';
    }
  }
  countDown(time?: any): void {
    let duration: number;
    duration = time;
    this.clearCountDown(); 
    this.interval = setInterval(() => {
      const minutes = parseInt((duration / 60).toString());
      const seconds = parseInt((duration % 60).toString());
      this.refreshTimer = (minutes < 10 ? '0' + minutes : minutes) + 'm' + ':' + (seconds < 10 ? '0' + seconds : seconds) + 's';
      duration--;
      if (duration < 0) {
        this.clearCountDown();
      }
    }, 1000);
  }
}
